const initialState = {}

const NotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case "notification":
            return {
                ...state,
                contact_count: action.data ? action.data.contact_count : [],
            }
        default:
            return state
    }
}

export default NotificationReducer
